import api from '../utils/request';
import { API_BASE_URL } from '../utils/config';

class PointsAPI {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  async getHistory(userId) {
    const response = await api.get(`/points/history/${encodeURIComponent(userId)}`);
    return response.data;
  }

  async recharge(userId, amountYuan) {
    const response = await api.post('/points/recharge', {
      user_id: userId,
      amount_yuan: amountYuan
    });
    return response.data;
  }

  async consumeByDuration(userId, durationSeconds, reason, sessionId, meta) {
    const payload = {
      user_id: String(userId),
      duration_seconds: Math.max(0, parseInt(durationSeconds || 0, 10)),
      reason: reason || 'usage',
      ...(sessionId ? { session_id: String(sessionId) } : {}),
      ...(meta ? { meta } : {})
    };
    const response = await api.post('/points/consume-by-duration', payload);
    return response.data;
  }
}

const pointsAPI = new PointsAPI();
export default pointsAPI;


